<template>
    <div style="background:white" class="ve-list-page">
        <div style=" background:white;line-height:30px;border-bottom:2px solid #389"> 
            <div style="padding-top:3px;display:flex;width:1400px; ">
                <div style="width:80px">
                    <i class="iconfont icon-xinzeng" style="color:#409EFF;font-size:14px;margin-right:5px;margin-left:8px;"></i>
                    <el-link :disabled="addBool" @click="addRec" :underline="false" style="margin-top:0px;"><span style="font-size:13px; ">{{ $LANG('0138', '新增') }} </span></el-link>
                </div>
                <div style="margin-right:10px;font-size:12px;margin-left:5px;">{{ $LANG('0312', '状态') }}</div>
                <el-select v-model="stfgSet"  size="small" @change="stfgChange" style="width:95px">
                    <el-option :label="$LANG('', '所有')" value="ALL"></el-option>
                    <el-option :label="$LANG('2005', '未审核')" value="N"></el-option>
                    <el-option :label="$LANG('1976', '已审核')" value="Y"></el-option>
                </el-select>
                <span style=" margin-left:20px;font-size:12px;margin-right:10px;">{{ $LANG('0681', '字段查询') }}</span>
                <el-select v-model="selparam" size="small" :placeholder="$LANG('1675', '请选择列名')" filterable  style="width:120px; " >
                    <span v-for="item in tabCol" :key='item.key'>
                        <el-option :label="$translate.getColTitle(item, $store.state.lang)" :value="item.key" v-if="item.thide=='N' "></el-option>
                    </span>
                </el-select>
                <el-input :placeholder="input_hold" v-model="txtparam" @keyup.enter.native="stfgChange" size="small" style="width:300px; height:30px; ">
                    <el-select v-model="oper" slot="prepend"   style="width:100px; " >
                        <span v-for="item in operArr" :key='item.IDSEQ'>
                            <el-option :label="item.CNAME" :value="item.SUBNO"></el-option>
                        </span>
                    </el-select>
                    <el-button size="small" slot="append" icon="el-icon-search" @click="stfgChange" ></el-button>
                </el-input> 
                <i class="iconfont icon-ziyuan" style="color:#409EFF;font-size:14px;margin:0 5px 0 15px;"></i>
                <el-link @click="openFieldSettingsDialog().catch(() => {})" :underline="false"><span style="font-size:12px;margin-right:15px;">{{ $LANG('0683', '字段设置') }}</span></el-link>
            </div>
        </div>
        <div class="ve-list-page__table">
        <ve-table :scroll-width="0"
              :columns="vueCol"
              :table-data="qcData"
              :columnHiddenOption="columnHiddenOption"
              class="custom-table-border"
              v-loading="v_loading"
              :element-loading-text="$LANG('1959', '加载中')"
              :border-around="true"
              :border-x="true"
              :border-y="true"
              :fixed-header="true"
              row-key-field-name="IDSEQ"
              :row-style-option="rowStyleOption"
              :cell-style-option="cellStyleOption"
              :max-height="subHeight"
              :virtual-scroll-option="virtualScrollOption"
              :column-width-resize-option="columnWidthResizeOption"
              :clipboardOption="{copy:true,paste:false,cut:false,delete:false}"
              :cellSelectionOption="{enable: false}"
              id="correct_rep"
              ref="refreq"
              style="margin-top:2px">
        </ve-table>
        </div>
        <!-- 分页查询 -->
        <div style="margin-top: 2px; overflow: hidden;display:flex;background:white;font-size:12px" class="ve-list-page__pagination">
            <div style="float: left;padding-left:4px;font-size:12px;">
                <Page :total="dataCount" :page-size="rowSize" show-total :current="current" @on-change="changePage"></Page>
            </div>
            <div style="line-height:30px;height:35px;width:500px;display:flex ; ">
                <div style="color:#606266; font-size:12px;width:35px;margin-left:15px">每页</div>
                <el-select v-model="rowSize" size="small" style="width:70px;"  @change="initPage">
                    <el-option 
                        v-for="item in pageList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
                <div style="color:#606266; margin-left:10px;font-size:12px;width:30px;">跳至</div>
                <el-input v-enter-number size="small" v-model="goPage" style="width:50px;"></el-input> 
                <span style="color:#606266; font-size:12px;margin-left:4px">页</span>
                <el-button @click="goNext" size="small" type="primary" style="width:40px;margin-left:15px;height:32px;">GO</el-button>
            </div>
        </div>
        <VeColumnConfigDialog
            :visible="fieldSettingDialog.visible"
            :rows="fieldSettingDialog.rows"
            :loading="fieldSettingDialog.loading"
            :error="fieldSettingDialog.error"
            :locked-field-keys="fieldSettingDialog.lockedFieldKeys"
            :drag-group-field="fieldSettingDialog.dragGroupField"
            :language="$store.state.lang"
            @update:visible="fieldSettingDialog.visible = $event"
            @change="updateFieldSettingsDraft"
            @confirm="saveFieldSettingsDialog"
            @reset="resetFieldSettingsDialog"
            @close="closeFieldSettingsDialog"
        />
        <!-- 提示框 -->
        <el-dialog :show-close="false" v-dialogDrag :visible.sync="promptWin" width="400px" append-to-body :close-on-click-modal="false" :close-on-press-escape="false" >
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'35px'}">
                <span style="line-height:35px;height:35px;font-size:14px;padding-left:5px;">提示</span>
            </div>
            <div style="line-height:30px;display:flex">
                <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
                <div style="font-size:12px;line-height:30px; ">{{prompt}}</div>
            </div>
            <div slot="footer">
                <el-button type="primary" ref="refbtn" size="small"  @click="promptWin=false" style="margin-right:20px;">确定</el-button>
            </div>
        </el-dialog>
        <!-- 新增、编辑表单 -->
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="addWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:36px;height:36px;font-size:15px;padding-left:5px;"><i class="iconfont icon-xuanze" style="margin-right:5px"></i>{{$route.meta.title}} ：{{ $LANG('0109', '明细资料') }}</span>
            </div> 
            <div style="height:88vh;overflow-y:auto">
                <span v-for="(gpitem,gpind) in formArr" :key="gpind"  >   
                    <div class="one-toolbar">
                        <span class="spanRow"> {{gpitem.gpnm}} </span>
                    </div>        
                    <Form :model="mainRow" :label-width="gpitem.gpnm=='注意事项'?160:120"  label-position="right" inline  :rules="ruleValidate">  
                        <span v-for="(item,index) in gpitem.gplist" :key="index" >
                            <FormItem  :label="$translate.getColTitle(item, $store.state.lang)"  :class=" item.EDCSS=='textarea'?'item-one':'item-width'" :prop="item.FLDNO"  v-if="item.FHIDE==='N'">
                                <el-date-picker size="medium" :disabled="saveFlag" type="date"  v-if="item.EDCSS==='date'" v-model="mainRow[item.FLDNO]"   value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>   
                                <el-input-number size="medium" :precision="item.DOTNUM" :disabled="saveFlag"  v-else-if="item.EDCSS==='number'" v-model="mainRow[item.FLDNO]" style="width:100%" ></el-input-number>   
                                <el-checkbox size="medium" :disabled="saveFlag" border v-else-if="item.EDCSS==='checkbox'" true-label="Y"  false-label="N" v-model="mainRow[item.FLDNO]" style="width:100%"></el-checkbox> 
                                <el-select size="medium" filterable clearable :disabled="item.DISABLED==='Y'?true:false||saveFlag" v-else-if="item.EDCSS==='select'" v-model="mainRow[item.FLDNO]"   style="width:100%">
                                    <el-option v-for="(item,index) in comboArr[item.FLDNO]" :key="index" :label="item.CNAME" :value="item.CNAME"></el-option>
                                </el-select>
                                <el-input size="medium" :disabled="saveFlag" v-else-if="item.EDCSS==='button'" v-model="mainRow[item.FLDNO]"  @focus="inputBtn('','',item.FLDNO)" style="width:100%;border:1px solid #778898"></el-input>
                                <el-select size="medium" filterable :disabled="saveFlag" v-else-if="item.key==='FRDEPTNO'||item.key=='TODEPTNO' "  style="width:100%" placeholder="请选择" v-model="mainRow[item.FLDNO]" >
                                    <el-option v-for="(item,index) in deptArr" :key="index" :value="item.CNAME" :label="item.CNAME"  >   </el-option>
                                </el-select>
                                <el-input resize="none" :disabled="saveFlag" v-else-if="item.EDCSS==='textarea'" type="textarea" :rows="4"  placeholder="请输入内容" v-model="mainRow[item.FLDNO]" maxlength="1500" show-word-limit ></el-input>
                                <el-input size="medium" :placeholder="item.HOLDER" type="text" v-else :disabled="item.DISABLED==='Y'?true:false||saveFlag "  v-model="mainRow[item.FLDNO]"></el-input>
                            </FormItem>
                        </span>
                    </Form>
                </span>
  
 
            </div>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; " >
                <span style="float:right">
 
                    <el-button type="info" size="small" icon="iconfont icon-shanchu"  @click="addWin=false" style="margin-right:25px;">取消</el-button>
                    <el-button :disabled="addBool||saveFlag"  type="primary" size="small" icon="iconfont icon-baocun"  @click="saveRec" style="margin-right:10px;">保存</el-button>
                </span>
            </div>
        </el-dialog>
         <!-- 引用选择框 -->
        <el-dialog  v-dialogDrag   :visible.sync="btnWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">选择记录</span>
            </div> 
            <pub-win v-bind:v_cond ="t_cond" v-bind:tabCol ="tableCol" v-bind:v_random="v_random" v-bind:v_table="v_table" v-bind:v_key2="v_key2" v-bind:v_value2="v_value2" @child-exit="btnWin=false" @child-sure="btnSure"></pub-win>                
        </el-dialog>

        <el-dialog  v-dialogDrag   :visible.sync="editWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">选择记录</span>
            </div> 
            <pub-edit v-bind:tabCol ="tableCol" v-bind:v_random="v_random" v-bind:v_table="v_table" v-bind:v_key2="v_key2" v-bind:v_value2="v_value2" @child-exit="editWin=false" @child-sure="btnSure"></pub-edit>                
        </el-dialog>
        <!-- report preview -->
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="repWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">报表预览</span>
            </div> 
            <div style="height:88vh;overflow-y:auto">
                <iframe :src="repUrl" frameborder="0" style="width: 100%; height: 100%"></iframe>
            </div>
        </el-dialog>
        <!-- 引用报表 -->
        <el-dialog  v-dialogDrag   :visible.sync="repDlg" width="550px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="6vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">报表参数</span>
            </div> 
            <rep-win v-bind:v_idno ="v_idno" v-bind:v_replist="v_replist" v-bind:v_corpid="v_corpid" @child-exit="repDlg=false" @child-sure="repShow"></rep-win>                
        </el-dialog> 
        <!-- 上传进度 -->
        <el-dialog :visible.sync="videoFlag" width="150px" append-to-body :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'30px'}">
                <span style="line-height:30px;height:30px;font-size:16px;padding-left:5px;">正在上传中...</span>
            </div>
            <el-progress   type="circle" :percentage="videoUploadPercent"  ></el-progress>  
        </el-dialog>
    </div>
</template>
<script>
import {getBaseData,getTabColOrData} from '../../api/user'; 
import { getDate} from '../../api/Select' 
import pubWin from '../datamgt/pubwin.vue'  
import repWin from '../datamgt/repWin.vue' 
import pubEdit from '../datamgt/pubmulti.vue'  
import createVeTableFieldSettingMixin from '@/utils/veTableFieldSettingMixin'
import VeColumnConfigDialog from '@/components/VeTable/VeColumnConfigDialog.vue'
import VeTableQueryHeader from '@/components/VeTable/VeTableQueryHeader.vue'
import { buildVeTableFieldCondition, buildVeTableHeaderCondition } from '@/utils/veTableHeaderQuery'
export default {
    name:'correct_rep',
    mixins: [
        createVeTableFieldSettingMixin({
            settingFormId: '412744',
            fieldIdseq: '412744',
            fieldLstseq: '1',
            mainColumnKey: 'tabCol',
            tableColumnKey: 'vueCol',
            initColumnKey: 'initCol',
            tableRef: 'refreq',
            generatedFixedColumnKeys: ['rownum', 'index', 'oper'],
        })
    ],
    data () {
        return {
            v_row:{},
            v_table:'',
            tableCol :[],
            v_key2 :'',
            v_value2 :'',
            toolFlag:false,
            qryCond:'',
 
            dtlRow:{},
            v_tabRow:{},
            v_tabIndex:'',
            chkIndex: 0,
            stfgBool:true,
            deptArr:[],
            v_commit :true,
            promptWin:false,
      
            dtlFlag:'create',
            prdRow:{},
            supFlag:'',
            addFlag:'create',
            formArr:[],
            rowDtl:{},
            btnWin:false,
            t_cond:'',
            editWin:false,
            stfgSet:'ALL',
            delDtlArr:[],
            prompt:'',
            input_hold:'请输入内容...',
            ruleValidate:{},
            selparam:'IDNO',
            txtparam:'',
            mainRow:{},
            prdFlag:'create',
            goPage:'',
            rowIdseq:'',
            qcData:[],
            cfmBool:false, //审核 权限
            addBool:false, //新增 权限
            editBool:false, //编辑权限
            appBool:false, //作废权限
            v_loading:false,
            current:1,
            saveFlag:false,
            allList:[], //询价单集合
            dtlData:[],
            matData:[],
            addWin:false,
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            
            v_corpid:this.$cookies.get('v_corpid') , //员工公司ID
            v_url:'xuper_auth/getTableRecMany', //api请求路径
            pageList: [{
                value: 50,
                label: '50'
                }, {
                value: 100,
                label: '100'
            }],
 
            dataCount:0,
            rowSize:50,
            hrCol:[],
            matCol:[],
            tabCol:[],
            initCol:[],
            vueCol:[],
            headerSortKey:'',
            headerSortOrder:'',
            queryRequestId:0,
            columnHiddenOption: { defaultHiddenColumnKeys: [] },
            rowStyleOption: { clickHighlight: true },
            cellStyleOption: {
                bodyCellClass: () => 'table-body-cell-class1',
                headerCellClass: ({ column }) => {
                    return column && (column.field === 'index' || column.key === 'rownum')
                        ? 'table-head-cell-class2'
                        : 'table-head-cell-class'
                },
            },
            virtualScrollOption: { enable: false },
            operArr:[],
            prcCol:[],
            prcData:[],
            prdIndex:'',
            oper:'like',
            v_key:'',
            v_idseq:this.$cookies.get('idseq'),
            dtlIndex:'',
            comboArr:[],
            tyArr:[],
            v_usernm:this.$cookies.get('v_usernm'), //api 请求用户
            repWin:false,
            repUrl:'',
            repDlg:false,
            v_idno:'',
            v_replist:[],
            repArr:[],
            v_random:'',
            v_admin:this.$cookies.get('v_admin') , 
            v_formurl:'xuper_auth/getFormGroup', 
            uploadData:{}, //上传数据
            videoFlag:false,
            videoUploadPercent:0,
            imgData:[],
            fileName:'',
       
            Accept: "png,jpg,jpeg,gif,tiff,pdf",
            delImg:[],
        }
    },
    components: {
      pubWin,  
      repWin,
      pubEdit,
      VeColumnConfigDialog,
    },
    computed: {
        subHeight: function() {
            return (window.innerHeight - 158) + 'px';
        }, 
        dtlHeight: function() {
            return (window.innerHeight - 385) + 'px';
        }, 
        tabWidth: function() {
            return (window.innerWidth - 140) + 'px';
        },
    },
    mounted () {
        //人员资料
        getBaseData('xuper_auth/getBaseData','CORPID',this.v_corpid ,'','','v_HR_DEPT','').then(res=>{
            this.deptArr =res.result
        })
        //表单资料分组 
        getTabColOrData(this.v_formurl,'v_sys_form_fld','idseq','412744','gpnm,gpsort','','lstseq','1', ' order by gpsort').then((res) => {
            this.formArr = res.result             
        })
        //操作符
        getBaseData('xuper_auth/getBaseData','PARENTNO','15995','','','v_sys_base','').then(res=>{
            this.operArr =res.result
        }) 
        getBaseData('xuper_auth/getBaseData','PARENTNO','16224','','','v_sys_base','').then(res=>{
            this.tyArr =res.result
        }) 
        getBaseData('xuper_auth/getBaseData'+'','userno',this.v_username,'frmidseq','412744','V_USER_MOD_REP','').then(res=>{
            this.repArr =res.result
        })
         //用户权限表
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','412744','v_sys_user_priv','').then(res=>{           
            if (this.v_admin==='N') { //表示有权限控制
                let row =res.result[0]
                if (row.ISADD==='N'){ //新增
                    this.addBool=true
                }if (row.ISUPD==='N'){ //修改
                    this.editBool=true
                }if (row.ISDEL==='N'){ //删除
                    this.delBool=true
                }if (row.ISCFM==='N'){ //审核
                    this.cfmBool=true
                }if (row.ISEXP==='N'){ //作废
                    this.appBool=true
                }
            }
        })    
         //动态生成表单验证规则
        getTabColOrData(this.v_url,'v_sys_form_fld','idseq','412744','LSTSEQ','1','NOTNULL','Y').then((res) => {
            let ruleObj={}
            let ruleVal=[]
            this.notNull = res.result
            res.result.forEach(item => {
                let v_fldnm =item.FLDNM
                let obj1={required:true,message:v_fldnm+'不能为空',trigger: 'blur'}
                ruleVal =[]
                ruleVal.push(obj1)
                ruleObj[item.FLDNO]=ruleVal                  
            });
            this.ruleValidate =ruleObj
        });
    },
    created () {
        if (this.v_username){
            this.getTabCol() //表列集合
            this.stfgChange('') //询价单主数据   
            this.comSelect() 
            this.showkey()
        }else{
            let routeUrl = this.$router.resolve({
                path: '/',
                query: {lang:this.LANG },
            });
            window.open(routeUrl.href, '_self'); 
        }
    },
    methods: {
        renderVeQueryHeader(column, item){
            const sortable = item.key !== 'STFG' && item.SORTABLE === 'N' && item.EDCSS !== 'checkbox'
            return <VeTableQueryHeader title={column.title} edcss={item.key === 'STFG' ? 'select' : item.EDCSS} value={this.v_row[item.key]} operator={this.v_row[`#OPER${item.key}`]} options={item.key === 'STFG' ? [{value:'Y', label:this.$LANG('1976', '已审核')}, {value:'N', label:this.$LANG('2005', '未审核')}] : []} showDateOperator={false} sortable={sortable} sortOrder={this.headerSortKey === item.key ? this.headerSortOrder : ''} on-input={value => this.$set(this.v_row, item.key, value)} on-operator-change={value => this.$set(this.v_row, `#OPER${item.key}`, value)} on-title-click={() => { if (sortable) this.sortHeaderColumn(column, item.EDCSS) }} on-query={this.stfgChange} />
        },
        sortHeaderColumn(column, edcss){
            const key = column && column.key
            if (!key) return
            this.headerSortOrder = this.headerSortKey === key && this.headerSortOrder === 'asc' ? 'desc' : 'asc'
            this.headerSortKey = key
            const direction = this.headerSortOrder === 'asc' ? 1 : -1
            const type = String(edcss || '').toLowerCase()
            this.allList.sort((left, right) => {
                const a = left && left[key]
                const b = right && right[key]
                if (a === b) return 0
                if (a === undefined || a === null || a === '') return -1 * direction
                if (b === undefined || b === null || b === '') return 1 * direction
                if (type === 'number') return (Number(a) - Number(b)) * direction
                return String(a).localeCompare(String(b), undefined, { numeric: true }) * direction
            })
            this.current = 1
            this.initPage()
        },
        rowShow(){
            this.v_row ={}
            this.stfgChange()
        } ,
        //禁止 键盘上、下键改变值
        showkey() {
            document.onkeydown = function () {
                if (window.event.keyCode === 38 || window.event.keyCode === 40) {
                    window.event.returnValue = false;
                }
            }
        },
         //预览PDF
        pdfViewer(path){
            let routeUrl = this.$router.resolve({
                path: '/fullPreview',
                query: {fileUrl: path},
            });
            window.open(routeUrl.href, '_blank');
        },
        //图片删除，操作数组
        imgDel(idseq,lstseq,path,index){
            this.$confirm('你确定要删除此附件吗','提示',{
                confirmButtonText: '确定',
                cancelButtonText:'取消',
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                this.delImg.push({IDSEQ:idseq,LSTSEQ:lstseq,FILEPATH:path}) 
                this.imgData.splice(index, 1);    
            }).catch(()=>{})
        },
        //上传显示进度
        handleProgress(event,file,fileList){
            this.videoFlag = true
            this.videoUploadPercent = Math.floor(event.percent)
        },
        //文件格式验证错误时的钩子
        handleFormatError (file) {
            this.promptWin =true
          this.prompt=this.$LANG('1455', '文件格式错误,')+file.name + this.$LANG('1431', ' 是不正确, 请选择pdf或图片格式')

        },
        //文件超出指定文件大小限制的钩子
        handleMaxSize (file) {
            this.promptWin =true
          this.prompt=file.name + this.$LANG('1561', '文件太大， 不能超出') + '2M'
        },
        // 文件上传成功时的钩子
        successImgFile(res,file){
            this.videoUploadPercent=0 
            this.videoFlag = false
            let v_filename='/assets/basedict/'+this.fileName+file.name.substring(file.name.lastIndexOf('.'))
            this.imgData.push({FILEPATH:v_filename})                   
        },
        //上传文件之前的钩子 /assets/basedict/"+code+"."+v_Suffix;
        beforeImgFile (res, file) {        
            this.fileName= this.v_username+getDate('year')+'-CK'     
            this.uploadData = {
                code: this.fileName ,
            }
            let promise = new Promise(resolve => {
            this.$nextTick(function() {
                    resolve(true);
                });
            });
            return promise; 

        },
 
        //报表运行
        repBtn(row){
            this.repDlg =true
            this.v_idno =row['IDNO']
            this.v_replist =this.repArr
        },
        repShow(row){
            if (!row['REPNO']){
                this.promptWin =true
              this.prompt =this.$LANG('1678', '请选择报表')
            }else{
                this.repWin =true
                this.repDlg =false
                this.repUrl =this.$store.state.repUrl+ row['REPNO']+'&p_corpid='+row['CORPID']+'&p_idno='+row['IDNO'] 
            }
        },
        //表格行 按回车键 到下一行
        btnSure(obj){
            if (this.v_key=='FREMPNO' ){
                let v_row={FREMPNO:obj['EMPNM'] }
                Object.assign(this.mainRow,v_row)     
                this.btnWin =false
            }else if (this.v_key=='TOEMPNO'  ){
                let v_row={TOEMPNO:obj['EMPNM'] }
                Object.assign(this.mainRow,v_row)     
                this.btnWin =false
            }
            
        },
        inputBtn(row,index, key){ 
            if (key=='FREMPNO' ||key=='TOEMPNO'){
                this.v_random=Math.random()    
                this.v_key =key         
                this.v_table ='v_HR_EMP'
                this.tableCol =this.hrCol
                this.v_key2 ='STFG'
                this.v_value2 ='Y'
                this.btnWin =true
            } 
        },
 
        //动态赋值下拉框
        comSelect(){  
            this.$axios({
                method:'post', 
                url: 'xuper_auth/getBaseData' ,
                data:{p_table:'v_sys_form_fld',p_key:'idseq',p_value:'412744',p_cond:' and lstseq in (1,2)',p_key2:'edcss',p_value2:'select'},
            }).then(res =>{
                if (res.result.length>0){
                    for(let k=0;k<res.result.length;k++){
                        getBaseData('xuper_auth/getBaseData','parentno',res.result[k].COMBO ,'','','v_sys_base','').then(res2=>{
                            this.comboArr[res.result[k].FLDNO] =res2.result
                        })
                    }
                }
            })  
        },
 
        //明细编辑、删除
        dtlDel(row,index){
            this.delDtlArr.push(row)
            this.dtlData.splice(index,1 )
        },
 
        dtlAdd(){
            // if (this.mainRow['POSEQ']){
            //     this.$axios({   
            //         method: 'post',
            //         url:'xuper_auth/getBaseData',
            //         data: {p_key:'idseq', p_value:this.mainRow['POSEQ'], p_table:'V_PO_DTL'},
            //     }).then(res=>{ 
            //         if (res.code=='200'){
            //             res.result.forEach(item=>{
            //                 let v_bool =true
            //                 this.dtlData.some(it=>{
            //                     if (it['REFPOSEQ']==item['IDSEQ'] && it['REFPOITM']==item['LSTSEQ']){
            //                         v_bool =false
            //                     }
            //                 })
            //                 if (v_bool){
            //                     let v_row={REFPOSEQ:item['IDSEQ'],REFPOITM:item['LSTSEQ'],MATNO:item['MATNO'],MATNM:item['MATNM'],
            //                         MATDESC:item['MATDESC'],MATTYNM:item['MATTYNM'],POUNITNM:item['POUNITNM'],QTY:item['QTY'],REC1:'Y',REC2:'Y',REC3:'Y',RESULTS:'Y'}
            //                     this.dtlData.push(v_row)
            //                 }
            //             })
            //         }
            //     }) 
            // }else{
            //     this.promptWin =true
            //     this.prompt ='采购订单不能为空'
            // }
            this.editWin =true   
        },
 
        //编辑记录
        editRec(row,val,index){
            if (val==='Y'){  //仅查看
                this.saveFlag=true
            }else{
                if (row.STFG==='Y'){
                    this.saveFlag=true
                }else{
                    this.saveFlag=false
                }   
            }
            this.addFlag='edit'
            this.mainRow =JSON.parse(JSON.stringify( row ))
            this.rowIdseq=row.IDSEQ
            //明细
            if (!this.mainRow['IDNO']){
                this.mainRow['DTTM']=getDate('day')
            }
            this.addWin=true   
            this.v_commit =true   
 
        },
        //保存记录
        saveRec(){
            this.notNull.some(item=>{  //forEach 没找到跳出循环，some：return true 跳出lop ,every：return false 跳出
                if (!this.mainRow[item.FLDNO] ){
                    this.stfgBool =false 
                    this.promptWin=true
                    this.prompt=item.FLDNM+'不能为空'
                    this.$refs['refbtn'].$el.focus()
                    return true
                }else{
                    this.stfgBool =true  
                }
            })
            //发起保存请求   
            if (this.stfgBool &&this.v_commit) { 
                this.v_commit =false   
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/formOneSave',
                    data: {p_json:JSON.stringify(Object.assign(this.mainRow,{CORPID:this.v_corpid })), p_table:'QC_CORRECT',frmid:'412744'},
                }).then(res=>{      
                    if(res.result ==='OK')  {  
                        let idseq_ =res.idseq
 
 
                        this.addWin =false   
                        this.getDataList('')
                    }else{
                        this.promptWin=true
                        this.prompt=res.result
                    }        
                }) 
            }
        },
        //新增
        addRec(){
            this.addWin=true
            this.mainRow={DTTM:getDate('day'),'IDSEQ':'',STFG:'N', 'RESULTS':'' }
            this.dtlData=[]
            this.saveFlag=false
            this.v_commit =true
            this.imgData =[]
        },
        //查询附件数据
        qryImgData(idseq){
            this.imgData=[]
            getTabColOrData(this.v_url,'V_mat_img','idseq',idseq,'','').then((res) => {              
                if (res){
                    this.imgData =res.result
                }
            })
        },
        getRowKey(row){
            return row.IDSEQ
        },
        getDtlKey(row){
            return row.index
        },
        tabRowClass({row,rowIndex}){  //为 table数据添加 index 字段
            row.index =rowIndex
        },
        rowClick(row){
            this.chkIndex =row.index
        },
         //状态变更
        stfgRec(row,val,index,v_comm){
            let v_cond ='' ,v_chkdttm='',v_chkuser='',v_cfmdttm='',v_cfmuser=''
            if (val =='K') {
                v_cfmdttm =getDate('full')
                v_cfmuser =this.v_usernm
                v_cond =' set stfg=\''+val+'\',appuser=\''+v_cfmuser+'\',appdttm=\''+v_cfmdttm+'\',chkuser=null,chkdttm=null'
            }else if (val =='Y'){
                v_chkdttm =getDate('full')
                v_chkuser =this.v_usernm
                v_cond =' set stfg=\''+val+'\',chkuser=\''+v_chkuser+'\',chkdttm=\''+v_chkdttm+'\''
            }else{
                v_chkuser='',v_chkdttm='',v_cfmuser='',v_cfmdttm=''
                v_cond =' set stfg=\''+val+'\',chkuser=\''+v_chkuser+'\',chkdttm=\''+v_chkdttm+'\',appuser=\''+v_cfmuser+'\',appdttm=\''+v_cfmdttm+'\''
            }
            if (val =='K' && row['FRUSER']==this.v_usernm ){
                this.promptWin =true
              this.prompt =this.$LANG('1889', '提出者与确认人不能相同，请核查')
            }else{
                this.$confirm(this.$LANG('1564', '你确定要')+v_comm+this.$LANG('1565', '此单据吗?'),this.$LANG('1442', '提示'),{
                  confirmButtonText: this.$LANG('1638', '确定'),
                  cancelButtonText:this.$LANG('0132', '取消'),
                  customClass:'messageBox',
                  showClose:false,
                  type:'info',
                }).then(()=>{
                    var vm=this;
                    this.$axios({
                        method: 'post',
                        url:'xuper_auth/updateRec',
                        data: {p_key:'idseq',p_value:row.IDSEQ,p_table:'QC_CORRECT',p_cond: v_cond},
                    }).then(res=>{      
                        if(res.code =='200')  {  
                            if (val =='X'){
                                this.qcData.splice(index,1)
                            } else{        
                                if (val =='Y'){
                                    Object.assign(row,{STFGNM:v_comm ,STFG:val, APPUSER:v_cfmuser,APPDTTM:v_cfmdttm})
                                }else{
                                    Object.assign(row,{STFGNM:v_comm ,STFG:val,CHKUSER:v_chkuser,CHKDTTM:v_chkdttm,APPUSER:v_cfmuser,APPDTTM:v_cfmdttm})
                                }
                            }
                        }    
                    })
                }).catch(()=>{})   
            }        
        },
        //状态查询
        stfgChange(){
            let condition = buildVeTableFieldCondition(this.initCol, this.selparam, this.txtparam, this.oper, { numberOperatorDefault: '>=' })
            condition += buildVeTableHeaderCondition(this.initCol, this.v_row, { numberOperatorDefault: '>=' })
            if (this.stfgSet !== 'ALL') condition += ` and stfg='${this.stfgSet}'`
            this.headerSortKey = ''
            this.headerSortOrder = ''
            this.current = 1
            this.getDataList(condition)
            return
        },
            /*
            let cond_=''
            if (this.selparam){ //列1
                if (this.oper==='like'){
                    cond_=cond_+' and  '+this.selparam+'  like  \'%' + this.txtparam+'%\' '
                }else if (this.oper==='!='){
                    cond_=cond_+' and  '+this.selparam+' is null '  
                }else{
                    cond_=cond_+' and  '+this.selparam  +this.oper+' \''+this.txtparam+'\' '
                }
            }
            let v_cond ='' ,v_edcss=''
            Object.keys(this.v_row).forEach(item=>{
                if (this.v_row[item] ){
                    this.tabCol.some(it=>{
                        if (it['key']== item){
                            v_edcss =it['edcss']
                        }
                    })
                    if (v_edcss =='number'){
                        v_cond =v_cond +' and '+item+'>='+  this.v_row[item] 
                    }else{
                        v_cond =v_cond +' and  '+item+'  like \'%'+ (this.v_row[item]).trim()+'%\''
                    }

                }
            })
            if (this.stfgSet!=='ALL'){
               cond_=cond_+' and  stfg=\''+this.stfgSet+'\''
            }
            this.getDataList(cond_+v_cond)
        }, 
            */
        goNext(){
            if (this.goPage){
                this.changePage(this.goPage)
                this.current =Number(this.goPage)
            }else{
                this.$alert('请输入跳至页数', '提示', {
                    confirmButtonText: '确定',
                    showClose:false,
                    type:'info'
                })
            }
        },
        //表格页面导航
        changePage(index){
            var _start = ( index - 1 ) * this.rowSize;
            var _end = index * this.rowSize
            this.current =index
            this.qcData = this.allList.slice(_start,_end);
        },
        //初始化查询页条数
        initPage(){
            //产品明细
            this.dataCount =this.allList.length //总条数
            // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
            if (this.allList.length < this.rowSize){
                this.qcData = this.allList          
            }else{
         
                if (this.current >1){
                    this.changePage(this.current)
                }else{
                    this.qcData =this.allList.slice(0,this.rowSize) //返回选定元素的子数组，不包含结尾元素
                }
            }
            this.$nextTick(() => {
                const table = this.$refs.refreq
                if (table && typeof table.doLayout === 'function') table.doLayout()
            }) 
        },
 
        //查询界面
        getDataList(p_cond){
            const requestId = ++this.queryRequestId
            this.v_loading =true
            const sortKey = this.headerSortKey || this.selparam || 'IDNO'
            const sortOrder = this.headerSortKey ? this.headerSortOrder : 'desc'
            getTabColOrData(this.v_url,'V_QC_CORRECT','','','CORPID',this.v_corpid,'','',p_cond +' order by '+sortKey+' '+sortOrder).then((res) => {
                if (requestId !== this.queryRequestId) return
                if (res.code=='200'){
                    this.allList =res.result 
                    this.initPage() 
                    this.$nextTick(()=>{
                        this.v_loading =false
                    })
                }else{
                    this.promptWin =true
                    this.prompt =res.result
                }
            }).catch(error => {
                if (requestId !== this.queryRequestId) return
                this.v_loading = false
                this.promptWin = true
                this.prompt = error && error.message ? error.message : this.$LANG('1641', '查询失败')
            })
        },
        renderMainHeaderCell(column, item){
            return this.renderVeQueryHeader(column, item)
        },
        renderMainFieldCell(row, item){
            if (item.key === 'IDNO') {
                return <el-link underline={false} on-click={() => this.repBtn(row)}><div style="color:#409eff;border-bottom:1px solid red;font-size:11px">{row[item.key]}</div></el-link>
            }
            if (item.EDCSS === 'checkbox') {
                return <el-checkbox disabled true-label="Y" false-label="N" v-model={row[item.key]} style="width:100%">&nbsp;</el-checkbox>
            }
            return <span>{row[item.key]}</span>
        },
        renderMainActionCell(row, rowIndex){
            return (
                <div>
                    <i class="iconfont icon-chakan" style="color:#409EFF;font-size:12px;margin-right:2px;"></i>
                    <el-link on-click={() => this.editRec(row, 'Y', rowIndex)} underline={false}><span style="font-size:12px;margin-right:5px">{this.$LANG('0139', '查看')}</span></el-link>
                    {row.STFG === 'N' ? <span>
                        <i class="iconfont icon-bianji" style="color:#409EFF;font-size:12px;margin-right:2px;"></i>
                        <el-link on-click={() => this.editRec(row, 'N', rowIndex)} underline={false}><span style="font-size:12px;margin-right:5px">{this.$LANG('1639', '编辑')}</span></el-link>
                    </span> : null}
                    {row.STFG === 'N' ? <span>
                        <i class="iconfont icon-shenhe" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                        <el-link disabled={this.appBool} on-click={() => this.stfgRec(row, 'K', rowIndex, '确认')} underline={false}><span style="font-size:12px;margin-right:5px">{this.$LANG('0364', '确认')}</span></el-link>
                    </span> : null}
                    {row.STFG === 'K' ? <span>
                        <i class="iconfont icon-fanshenhe" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                        <el-link disabled={this.appBool} on-click={() => this.stfgRec(row, 'N', rowIndex, '弃认')} underline={false}><span style="font-size:12px;margin-right:5px">{this.$LANG('0314', '弃认')}</span></el-link>
                    </span> : null}
                    {row.STFG === 'K' ? <span>
                        <i class="iconfont icon-shenhe" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                        <el-link disabled={this.cfmBool} on-click={() => this.stfgRec(row, 'Y', rowIndex, '审核')} underline={false}><span style="font-size:12px;margin-right:5px">{this.$LANG('0134', '审核')}</span></el-link>
                    </span> : null}
                    {row.STFG === 'Y' ? <span>
                        <i class="iconfont icon-fanshenhe" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                        <el-link disabled={this.cfmBool} on-click={() => this.stfgRec(row, 'K', rowIndex, '弃审')} underline={false}><span style="font-size:12px;margin-right:5px">{this.$LANG('0137', '弃审')}</span></el-link>
                    </span> : null}
                    {row.STFG === 'N' ? <span>
                        <i class="iconfont icon-shanchu1" style="color:#409EFF;font-size:12px;margin-right:2px;"></i>
                        <el-link on-click={() => this.stfgRec(row, 'X', rowIndex, '作废')} underline={false}><span style="font-size:12px">{this.$LANG('0257', '作废')}</span></el-link>
                    </span> : null}
                </div>
            )
        },
        //获取表列头字段  v-enter-number
        getTabCol(){
            var vm=this
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','412744','lstseq','1','','',' order by sortby,lstseq' ).then((res) => {
                vm.initCol = res.result
                return vm.loadInitialFieldSettings().then(() => {
                    const fieldRows = vm.sortFieldRows(vm.initCol)
                    vm.tabCol = []
                    vm.vueCol = []
                    fieldRows.forEach(rowField => {
                        const itcol = rowField
                        const title = vm.$translate.getColTitle(itcol, vm.$store.state.lang)
                        vm.tabCol.push({ title, key: itcol.key, align: itcol.align, width: itcol.width, thide: itcol.THIDE, fhide: itcol.FHIDE, edcss: itcol.EDCSS, disabled: itcol.DISABLED, dotnum: itcol.DOTNUM, holder: itcol.HOLDER, sortable: itcol.SORTABLE })
                        if (itcol.THIDE !== 'N') return
                        vm.vueCol.push({
                            field: itcol.key,
                            key: itcol.key,
                            title,
                            type: itcol.EDCSS === 'checkbox' ? 'check' : itcol.EDCSS,
                            align: itcol.align,
                            width: Number(itcol.width) || 120,
                            sortable: false,
                            ellipsis: { showTitle: true },
                            renderHeaderCell: ({column}) => <VeTableQueryHeader title={column.title} edcss={itcol.key === 'STFG' ? 'select' : itcol.EDCSS} value={vm.v_row[itcol.key]} operator={vm.v_row[`#OPER${itcol.key}`]} options={itcol.key === 'STFG' ? [{value:'Y', label:vm.$LANG('1976', '已审核')}, {value:'N', label:vm.$LANG('2005', '未审核')}] : []} showDateOperator={false} sortable={itcol.key !== 'STFG' && itcol.SORTABLE === 'N' && itcol.EDCSS !== 'checkbox'} sortOrder={vm.headerSortKey === itcol.key ? vm.headerSortOrder : ''} on-input={(value) => vm.$set(vm.v_row, itcol.key, value)} on-operator-change={(value) => vm.$set(vm.v_row, `#OPER${itcol.key}`, value)} on-title-click={() => { if (itcol.key !== 'STFG' && itcol.SORTABLE === 'N' && itcol.EDCSS !== 'checkbox') vm.sortHeaderColumn(column, itcol.EDCSS) }} on-query={() => vm.stfgChange()} />,
                            renderBodyCell: ({row}) => vm.renderMainFieldCell(row, itcol),
                        })
                    })
                    vm.vueCol.unshift({
                        field: 'index', key: 'rownum', title: vm.$LANG('0310', '序号'), width: 60, align: 'center', fixed: 'left', disableResizing: true,
                        renderBodyCell: ({rowIndex}) => rowIndex + 1,
                        renderHeaderCell: () => (
                            <el-link on-click={vm.rowShow} style="font-size:12px;color:#404eff">
                                <el-tooltip content={vm.$LANG('0852', '清除条件')} effect="light"><i class="iconfont icon-shanchu1"></i></el-tooltip>
                            </el-link>
                        ),
                    })
                    vm.vueCol.push({
                        field: 'oper0', key: 'oper', title: vm.$LANG('0330', '状态操作'), width: 215, align: 'center', fixed: 'right', disableResizing: true,
                        renderBodyCell: ({row, rowIndex}) => vm.renderMainActionCell(row, rowIndex),
                    })
                    vm.applyFieldSettingRows()
                    return res
                })
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','4204','lstseq','1','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.hrCol.push({ //向数组的开头 添加序列号
                      title: vm.$translate.getColTitle(res.result[k], vm.$store.state.lang),
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        edcss:res.result[k].EDCSS,
                        sortable:res.result[k].SORTABLE,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        notnull:res.result[k].NOTNULL,
                    })
                }
            })
        },
    }
}
</script>
<style scoped lang="less">
    .item-width  {
        height:22px;
        width: 32%;
    }
    .item-one {
        width: 97%;
        height:88px;
    }
    .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 0 auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }
</style>
<style lang="less">
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .el-table {
        th {
            padding: 0 ;
        }
        thead{
            height: 15px;
            color:rgb(11, 11, 59);
            font-size:12px;
            background:rebeccapurple;
        }
        td {
            padding: 5px ;
            font-size:11px;
        } 
    }
    .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    //.el-dialog__headerbtn i { background:white;font-size: 20px;  }
    .el-table .success-row {
        color:#959997;
    }
    .el-table .cancel-row {
        color: #e00e66;
    }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
        border-color :#3d77eb;
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label{
        color:#3d77eb
    }
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
</style>
